// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XJx_TnnOQYlAiRTg{--text-font-size: 10px;--text-line-height: 12px}.DWDcZjpNpLckQvZd{--text-font-size: 12px;--text-line-height: 16px}.QKx3aDIIiUkDJCb9{--text-font-size: 14px;--text-line-height: 16px}.f2HUStjbRxYAHlcF{--text-font-size: 16px;--text-line-height: 24px}.lrxGuDZ4p8sO9n7j{--text-font-size: 18px;--text-line-height: 24px}.I1_p6AcJUFhZAVKs{--text-font-size: 20px;--text-line-height: 32px}.peD3pp4vzTwbbXQ7{--text-font-size: 24px;--text-line-height: 32px}.tqE9OZEotSAuBIBG{--text-font-size: 28px;--text-line-height: 40px}.xmV46vP8NwcN2zwE{--text-font-size: 32px;--text-line-height: 40px}.gDLtCAHhK4UrORV1{--text-font-size: 40px;--text-line-height: 48px}.MvawxEkhAI8gDVHN{--text-font-size: 48px;--text-line-height: 56px}.mcclsiCL2LklBbWQ{--text-font-weight: 300}.xh5AYAWm8DsMxDub{--text-font-weight: 400}.DEkdbcURi8SE2o_T{--text-font-weight: 600}.bUKdMKgSihsFz83o{--text-font-weight: 700}.LGh2bEEpB5I6DUTV{--text-font-weight: 900}.fpQBTW820gV6wVXt{font-size:var(--text-font-size);font-weight:var(--text-font-weight);line-height:var(--text-line-height)}.efTnE_TBHEIGT8mk{font-style:italic}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text-extra-small": `XJx_TnnOQYlAiRTg`,
	"text-caption": `DWDcZjpNpLckQvZd`,
	"text-paragraph-3": `QKx3aDIIiUkDJCb9`,
	"text-paragraph-2": `f2HUStjbRxYAHlcF`,
	"text-paragraph-1": `lrxGuDZ4p8sO9n7j`,
	"text-sub-heading": `I1_p6AcJUFhZAVKs`,
	"text-heading-5": `peD3pp4vzTwbbXQ7`,
	"text-heading-4": `tqE9OZEotSAuBIBG`,
	"text-heading-3": `xmV46vP8NwcN2zwE`,
	"text-heading-2": `gDLtCAHhK4UrORV1`,
	"text-heading-1": `MvawxEkhAI8gDVHN`,
	"text-light": `mcclsiCL2LklBbWQ`,
	"text-regular": `xh5AYAWm8DsMxDub`,
	"text-semi-bold": `DEkdbcURi8SE2o_T`,
	"text-bold": `bUKdMKgSihsFz83o`,
	"text-black": `LGh2bEEpB5I6DUTV`,
	"text": `fpQBTW820gV6wVXt`,
	"italic": `efTnE_TBHEIGT8mk`
};
export default ___CSS_LOADER_EXPORT___;
